module.exports = __webpack_public_path__ + "static/media/search_dest.ae1796a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/cota/images/search_dest.svg
// module id = 617
// module chunks = 0